import {apiGet, apiPost} from '@api/api'
import {ApiRes} from '@type/api'
import {IProfile} from '@type/profile'
import {IConfirmResponse} from '@api/auths/register/Register'

export const apiUnfollow = async (user_id?: string): Promise<ApiRes<IConfirmResponse>> => {
    return await apiPost(`unfollow`, {followee_id: user_id})
}
